import { render } from "./ReeferFriend.vue?vue&type=template&id=46246f3c&scoped=true"
import script from "../js/reefer-friend.js?vue&type=script&lang=js"
export * from "../js/reefer-friend.js?vue&type=script&lang=js"

import "./ReeferFriend.vue?vue&type=style&index=0&id=46246f3c&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46246f3c"]])

export default __exports__